import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface NotificationCardProps {
  timestamp: string;
  title: string;
  description: string;
  actionText?: string;
  onActionClick?: () => void;
  isRead?: boolean;
  className?: string;
}

export default function NotificationCard({
  timestamp,
  title,
  description,
  actionText = "Respond to request",
  onActionClick,
  isRead = false,
  className,
}: NotificationCardProps) {
  return (
    <div
      className={cn(
        "bg-white border border-gray-200 rounded-lg p-4 space-y-3",
        !isRead && "border-l-4 border-l-primary",
        className
      )}
    >
      {/* Timestamp with green dot */}
      <div className="flex items-center gap-2">
        <div className="w-2 h-2 bg-primary rounded-full"></div>
        <span className="text-sm text-gray-600">{timestamp}</span>
      </div>

      {/* Title */}
      <h3 className="font-semibold text-gray-900 text-base">{title}</h3>

      {/* Description */}
      <p className="text-sm text-gray-600 leading-relaxed">{description}</p>

      {/* Action Button */}
      {actionText && (
        <Button
          variant="outline"
          size="sm"
          onClick={onActionClick}
          className="border-primary text-primary hover:bg-primary/10 hover:text-primary"
        >
          {actionText}
        </Button>
      )}
    </div>
  );
}
